import hash from 'string-hash';

let cache = (<any>window).__f9publicCache || ((<any>window).__f9publicCache = {}),
    getKey = (name: string): string => `c${hash(name)}`;

export function getCacheItem<T>(name: string): T {
    const key = getKey(name);
    return <T>(cache[key] || (cache[key] = null));
}

export function setCacheItem<T>(name: string, item: T): T {
    const key = getKey(name);
    return (cache[key] = item);
}

export function clearCache(name: string = ""){
    if(name) {
        delete cache[getKey(name)];
    } else {
        cache = (<any>window).__f9publicCache = {};
    }
}

export default {
    get: getCacheItem,
    set: setCacheItem,
    clear: clearCache
}